import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllPhcDeaerators = async (page, size, searchString) => {
  const response = await api.get(`/${ENDPOINTS.DEAERATORS_PHC}`, {
    params: {
      page,
      size,
      search: searchString,
    },
  });

  return response.data;
};